var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.onPrivateMessage.apply(null, arguments)
            },
          },
        },
        [
          _vm._v("\n    Nachrichten "),
          _vm.directChannel && _vm.directChannel.numUnreadMessages
            ? _c("span", { staticClass: "badge bg-danger" }, [
                _vm._v(_vm._s(_vm.directChannel.numUnreadMessages)),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-secondary ms-1",
          on: {
            click: function ($event) {
              $event.preventDefault()
              _vm.displayAppRequestForm = !_vm.displayAppRequestForm
            },
          },
        },
        [_vm._v("\n    Termin-Anfrage\n  ")]
      ),
      _vm._v(" "),
      _vm.displayAppRequestForm
        ? _c("appointment-request", {
            staticClass: "mt-3",
            on: {
              submit: function ($event) {
                return _vm.onAppointmentRequest($event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }